export const ooraTrafficDatasetReducer = (state = {}, action) => {
  switch (action.type) {
    // LIST
    case "GET_OORA_TRAFFIC_DATASET_LIST_REQUEST":
      return { ...state, loading: true, listLoading: true };

    case "GET_OORA_TRAFFIC_DATASET_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        listLoading: false,
        ooraTrafficDatasetList: action.payload,
        listError: null,
      };

    case "GET_OORA_TRAFFIC_DATASET_LIST_FAILED":
      return { ...state, loading: false, listLoading: false, listError: action.payload };

    // SINGLE (VIEW)
    case "GET_OORA_TRAFFIC_DATASET_REQUEST":
      return { ...state, loading: true, singleLoading: true, singleError: null };

    case "GET_OORA_TRAFFIC_DATASET_SUCCESS":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        ooraTrafficDataset: action.payload,
        singleError: null,
      };

    case "GET_OORA_TRAFFIC_DATASET_FAIL":
      return { ...state, loading: false, singleLoading: false, singleError: action.payload };

    // FETCH (create / append new dates)
    case "FETCH_OORA_TRAFFIC_DATASET_REQUEST":
      return { ...state, loading: true, fetchLoading: true, fetchError: null };

    case "FETCH_OORA_TRAFFIC_DATASET_SUCCESS":
      return {
        ...state,
        loading: false,
        fetchLoading: false,
        fetchResult: action.payload, // has already_exists, added_dates, failed
        fetchError: null,
      };

    case "FETCH_OORA_TRAFFIC_DATASET_FAILED":
      return { ...state, loading: false, fetchLoading: false, fetchError: action.payload };

    // REMOVE
    case "REMOVE_OORA_TRAFFIC_DATASET_REQUEST":
      return { ...state, loading: true, removeLoading: true };

    case "REMOVE_OORA_TRAFFIC_DATASET_SUCCESS":
      return { ...state, loading: false, removeLoading: false, removeError: null };

    case "REMOVE_OORA_TRAFFIC_DATASET_FAILED":
      return { ...state, loading: false, removeLoading: false, removeError: action.payload };

    case "GET_OORA_JAM_PATCH_LIST_REQUEST":
      return { ...state, loading: true, patchLoading: true };

    case "GET_OORA_JAM_PATCH_LIST_SUCCESS":
      return { ...state, loading: false, patchLoading: false, ooraJamPatchList: action.payload, patchError: null };

    case "GET_OORA_JAM_PATCH_LIST_FAILED":
      return { ...state, loading: false, patchLoading: false, patchError: action.payload };

    case "LIVE_SYNC_OORA_TRAFFIC_REQUEST":
      return { ...state, loading: true, liveSyncLoading: true };

    case "LIVE_SYNC_OORA_TRAFFIC_SUCCESS":
      return { ...state, loading: false, liveSyncLoading: false, liveSyncResult: action.payload };

    case "LIVE_SYNC_OORA_TRAFFIC_FAILED":
      return { ...state, loading: false, liveSyncLoading: false };

    case "RESET_OORA_TRAFFIC_DATASET":
      return {
        ...state,
        ooraTrafficDataset: null,
        fetchResult: null,
        singleError: null,
        fetchError: null,
        removeError: null,
        listError: null,
      };

    default:
      return state;
  }
};